'use client'

import { useMemo } from 'react'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import Navbar from '@dd3tech/wiggui/Navbar'
import IconWiggot from '@dd3tech/wiggui/IconWiggot'
import Tooltip from '@dd3tech/wiggui/Tooltip'
import Text from '@dd3tech/wiggui/Text'
import ToastProvider from '@dd3tech/wiggui/ToastProvider'
import ProgressBar from '@dd3tech/wiggui/ProgressBar'
import { ROUTES } from '../../constants'

interface MinimalistStepNavbarProps {
  backRoute?: string
  tooltipContent?: string
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left'
  title?: string
  currentStep?: number
  maxStep?: number
  showBar?: boolean
}

const WrapperCloseIcon = ({
  tooltipContent,
  tooltipPlacement = 'top'
}: {
  tooltipContent?: string
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left'
}) => {
  const Icon = <GoogleIcon name="close" className="text-surface-dark" />

  if (!tooltipContent) {
    return Icon
  }

  return (
    <Tooltip placement={tooltipPlacement} content={tooltipContent}>
      {Icon}
    </Tooltip>
  )
}

export const MinimalistStepNavbar = ({
  backRoute,
  tooltipContent,
  title,
  currentStep,
  maxStep,
  tooltipPlacement,
  showBar = true
}: MinimalistStepNavbarProps) => {
  const progress = useMemo(() => {
    if (!currentStep || !maxStep) {
      return 0
    }
    return (currentStep / maxStep) * 100
  }, [currentStep, maxStep])

  return (
    <>
      <Navbar className="row-span-1 col-span-full z-2 w-full bg-white items-center relative">
        <Navbar.Left className="flex-initial !h-[37px] flex-shrink-0 !justify-center w-fit">
          <button
            type="button"
            onClick={() => (window.location.href = ROUTES.HOME)}
          >
            <IconWiggot variant="black" />
          </button>
        </Navbar.Left>
        <Navbar.Right>
          {title && (
            <Text className="text-primary text-body-bold-m">{title}</Text>
          )}
          {currentStep && maxStep && (
            <Text className="text-secondary text-body-m">
              {currentStep} de {maxStep}
            </Text>
          )}
          {backRoute && (
            <Navbar.InteractionIcons
              interactionIcons={[
                {
                  hideOnMobile: false,
                  icon: (
                    <WrapperCloseIcon
                      tooltipPlacement={tooltipPlacement}
                      tooltipContent={tooltipContent}
                    />
                  ),
                  onClick: () => (window.location.href = backRoute)
                }
              ]}
            />
          )}
        </Navbar.Right>
        {showBar && progress !== 0 && (
          <div className="absolute bottom-0 left-0 right-0">
            <ProgressBar barBgColor="bg-primary" progress={progress} />
          </div>
        )}
      </Navbar>
      <ToastProvider />
    </>
  )
}
